<div class="flex items-center gap-8 mb-4">
  <button class="px-4 py-2  text-white rounded-lg" [class.bg-blue-700]="view === 'dashboard'"
    [class.bg-gray-400]="view !== 'dashboard'" (click)="showDahboard()"> {{ 'DASHBOARD.DASHBOARD' | translate }} </button>

  <button class="px-4 py-2 text-white rounded-lg" [class.bg-blue-700]="view === 'tasks'"
    [class.bg-gray-400]="view !== 'tasks'" (click)="showTasks()">
    {{ 'DASHBOARD.TASKS' | translate }}
  </button>
</div>
@if (view === 'dashboard') {
<div class="dashboard ">
  <app-sale></app-sale>
  <!-- Mobile bottom menu only -->
  <div class="">
    <app-menu-bottom></app-menu-bottom>
  </div>
</div>
}

@if (view === 'tasks') {
<app-dashboard-tasks></app-dashboard-tasks>
}